<ngx-ui-loader [loaderId]="'individualpump'"></ngx-ui-loader>
<div id="denyDashboardAccess" class="background">
<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <mat-card class="shadows" style="height: 14vh;">
                <mat-card-content>
                  <div class="row">
                    <div class="col-md-2">
                      <ng-select 
                        [items]="transformerList" 
                        bindLabel="label"
                        placeholder="Transformer"
                        [(ngModel)]="selectedTransformerForHealth"
                        (change)="OnFilterChange(selectedTransformerForHealth.transformerid, 'transformer')"
                        [clearable]="false">
                      </ng-select>
                    </div>
              
                    <div class="col-md-2">
                      <ng-select
                        [items]="pumpIdsArray"
                        bindLabel="label"
                        bindValue="value"
                        [(ngModel)]="selectedpump"
                        (change)="OnFilterChange(selectedpump, 'pump')"
                        [clearable]="false">
                      </ng-select>
                    </div>
              
                    <div class="col-md-2">
                      <mat-label>Select Duration </mat-label>  
                      <mat-select [(ngModel)]="selectedDuration" (selectionChange)="onDurationChange()">
                        <mat-option *ngFor="let time of durationList" [value]="time">
                          {{ time.name }}
                        </mat-option>
                      </mat-select>
                    </div>
                    
              
                    <div class="col-md-6 d-flex justify-content-between">
                      <div class="text-center">
                     <div style="font-size: small; font-weight: bold;">Transformer Buchholz act</div>
                        
                        <img src="{{ buchholz == 0 ? '../assets/images/green.png' : '../assets/images/red.png' }}" alt="Image"
                          class="blinking-image" style="max-width: 100%; max-height: 23%; display: block; margin: 0 auto;">
                        </div>
              
                      <div class="text-center">
                        <div style="font-size: small; font-weight: bold;">AB Switch Status</div>
                        <img src="../assets/images/{{ abswitch == 1 ? 'greenSwitch.png' : 'redSwitch.png' }}" alt="Switch Status" style="max-width: 100%; max-height: 24%; display: block; margin: 0 auto;">
                        
                      </div>
                      
                      <div class="text-center">
                        <div style="font-size: small; font-weight: bold;">Lightning Transformer Feedback</div>
                        <img src="../assets/images/{{ lightningTransformerFeedback == 1 ? 'greenSwitch.png' : 'redSwitch.png' }}" alt="Lightning Transformer Feedback" style="max-width: 100%; max-height: 24%; display: block; margin: 0 auto;">
                       
                      </div>
              
                      <div class="text-center">
                        <div style="font-size: small; font-weight: bold;">Pump  Status</div>
                        <img src="../assets/images/{{ pumponestatus == 1 ? 'greenSwitch.png' : 'redSwitch.png' }}" alt="Pump 1 Status" style="max-width: 100%; max-height: 24%; display: block; margin: 0 auto;">
                        
                      </div>

                      <div class="text-center">
                        <div style="font-size: small; font-weight: bold;">Pump Running Time</div>
                        <ng-container *ngIf="totalPumpOnTimeInDays > 0">
                           {{totalPumpOnTimeInDays}}D
                        </ng-container >
                       <p style="font-weight:bolder"> {{totalPumpOnTimeInHours}}H:{{totalPumpOnTimeInMinutes}}M:{{totalPumpOnTimeInSeconds}}S
                     
                     </p> </div>
                      

                    </div>
                    
                  </div>
                </mat-card-content>
              </mat-card>
              
        </div>
    </div>
    <br>

    <div class="row">
        <div class="col-md-12">
            <mat-card
      style="height: 104%; box-shadow: 0px 0px 5px 5px #888888; border-radius: 0px; border: 0px solid #FFFFFF; position: relative;">
      <div style="width:98%;position: absolute; top: 1%; left: 1%; z-index: 1; ">
       
        <div style="display: flex;overflow-x: auto;">
          <button mat-button style="min-width: 120px; background-color: #f44336; color: white;"
            (click)="updateSelected('motorrphasetemperature')">Phase Temp</button>
          <button mat-button style=" margin-left: 10px;min-width: 100px; background-color: #2196f3; color: white;"
            (click)="updateSelected('pumpcurrent')">Current</button>
          <button mat-button style="margin-left: 10px; min-width: 100px; background-color: #4caf50; color: white;"
            (click)="updateSelected('motordetemperature')">De Temp</button>
          <button mat-button style="margin-left: 10px; min-width: 100px; background-color: #ff9800; color: white;"
            (click)="updateSelected('motorndetemperature')">Nde Temp</button>
          <button mat-button style="margin-left: 10px; min-width: 175px; background-color: #4caf50; color: white;"
            (click)="updateSelected('pumpdplow')">Discharge Pressure Low</button>
          <button mat-button style="margin-left: 10px; min-width: 100px; background-color: #ff9800; color: white;"
            (click)="updateSelected('overload')" >OverLoad</button>
          <button mat-button style="margin-left: 10px; min-width: 100px; background-color: #59d6aa; color: white;"
            (click)="updateSelected('Water_Flow')">Water Flow</button>
          <button mat-button style="margin-left: 10px; min-width: 100px; background-color: #834496; color: white;"
            (click)="updateSelected('Sump_Level')">Sump Level</button>
          <button mat-button style="margin-left: 10px; min-width: 140px; background-color: #f44336; color: white;"
            (click)="updateSelected('pumponffeedback')">Pump Feedback</button>
        </div>
      </div>
      
      <div *ngIf="hasData; else noDataTemplate">
        <ngx-ui-loader [loaderId]="'indgraph'"></ngx-ui-loader>

        <plotly-plot [data]="data" [layout]="graph.layout" [config]="graph.config" [useResizeHandler]="true"
                     [style]="{ width: '100%', height: '100%', position: 'relative', top: '10px' }">
        </plotly-plot>
      </div>
      <ng-template #noDataTemplate>
        <div class="no-data-container">
          <p style="font-weight: bolder;">No data to show</p>
        </div>
      </ng-template>
      
    </mat-card>
        </div>
    </div>
</div>
</div>